<div
  class="genesys-call-log-container"
  data-qa="genesys-call-log_report"
  *ngIf="areFormsInitialized"
>
  <!-- #region LEFT PANEL CALL LOG-->
  <div class="genesys-call-log__left">
    <!-- #region GENERAL CALL LOG FORM-->
    <form
      class="genesys-call-log__form-group"
      data-qa="genesys-call-log_report_form_general"
      [formGroup]="generalForm"
    >
      <div class="genesys-call-log__field">
        <horizon-text-input
          [disabled]="true"
          [label]="'call_log.call_log_report_view.general.direction'"
          [iconName]="generalFormIcon.direction.iconName"
          [iconColor]="generalFormIcon.direction.iconColor"
          [name]="'direction'"
          [hasIconLink]="true"
          [iconSize]="'16'"
          [control]="generalForm?.controls['direction']"
        ></horizon-text-input>
      </div>
      <div class="genesys-call-log__field">
        <horizon-text-input
          [disabled]="true"
          name="id_v"
          [iconName]="generalFormIcon.id_v.iconName"
          [iconGroup]="generalFormIcon.id_v.iconGroup"
          [iconColor]="generalFormIcon.id_v.iconColor"
          [hasIconLink]="true"
          [iconSize]="'16'"
          [label]="'call_log.call_log_report_view.general.id'"
          [control]="generalForm?.controls['id_v']"
        ></horizon-text-input>
      </div>
      <div class="genesys-call-log__field">
        <horizon-text-input
          [disabled]="true"
          name="vulnerability"
          [iconName]="generalFormIcon.vulnerability.iconName"
          [iconGroup]="generalFormIcon.vulnerability.iconGroup"
          [iconColor]="generalFormIcon.vulnerability.iconColor"
          [hasIconLink]="true"
          [iconSize]="'16'"
          [label]="'call_log.call_log_report_view.general.vulnerability'"
          [control]="generalForm?.controls['vulnerability']"
        ></horizon-text-input>
      </div>
      <div class="genesys-call-log__field">
        <horizon-switch-input
          data-qa="genesys-call-log_report_general_switch_refuse-to-verify"
          [label]="'call_log.call_log_report_view.general.refuse_to_verify'"
          [isDisabled]="!isEditMode || isUnauthorised || isTransferred"
          [checked]="customerRefusesToVerify"
          [showIcon]="true"
          (valueChanged)="refuseToCompleteIDVChanged($event)"
        ></horizon-switch-input>
      </div>
      <div class="genesys-call-log__field">
        <horizon-dropdown
          data-qa="genesys-call-log_report_general_dropdown_category"
          [enable]="true"
          [label]="'call_log.call_log_report_view.general.category'"
          [dropdownValues]="categoryOptions"
          [fields]="categoryOptionsValues"
          [showClearButton]="false"
          [filtering]="false"
          [control]="generalForm?.controls['category']"
          (valueSelected)="categoryChanged($event)"
        >
        </horizon-dropdown>
      </div>
      <div class="genesys-call-log__field">
        <horizon-switch-input
          data-qa="genesys-call-log_report_general_switch_already-completed"
          [label]="'call_log.call_log_report_view.general.already_completed'"
          [isDisabled]="true"
          [checked]="isTransferred"
          [showIcon]="true"
          (valueChanged)="idVAlreadyCompleted($event)"
        ></horizon-switch-input>
      </div>
      <div class="genesys-call-log__field">
        <horizon-text-input
          [disabled]="true"
          name="callFromTo"
          [label]="'call_log.call_log_report_view.general.call_from_to'"
          [control]="generalForm?.controls['callFromTo']"
        ></horizon-text-input>
      </div>
      <div class="genesys-call-log__field">
        <horizon-text-input
          *ngIf="!isAgentCalling || !isEditMode"
          [disabled]="true"
          name="successfulContact"
          [label]="'call_log.call_log_report_view.general.successful_contact'"
          [control]="generalForm?.controls['successfulContact']"
          (valueChange)="successfulContactChanged($event)"
        ></horizon-text-input>
        <horizon-dropdown
          *ngIf="isAgentCalling && isEditMode"
          data-qa="genesys-call-log_report_general_dropdown_successful-contact"
          class="inputs__item"
          [label]="'call_log.call_log_report_view.general.successful_contact'"
          [dropdownValues]="successfulContactOptions"
          [value]="generalFormData.rows[0].successfulContact?.value"
          [fields]="successfulContactOptionsValues"
          [showClearButton]="true"
          [filtering]="false"
          [enabled]="true"
          (valueSelected)="successfulContactChanged($event)"
        ></horizon-dropdown>
      </div>
      <div class="genesys-call-log__field">
        <horizon-text-input
          [disabled]="true"
          name="accountNumber"
          [label]="'call_log.call_log_report_view.general.account_number'"
          [control]="generalForm?.controls['accountNumber']"
        ></horizon-text-input>
      </div>
      <div class="genesys-call-log__field">
        <horizon-text-input
          [disabled]="true"
          name="relationship"
          [label]="'call_log.call_log_report_view.general.relationship'"
          [control]="generalForm?.controls['relationship']"
        ></horizon-text-input>
      </div>
      <div
        *ngIf="linkedAccounts?.length > 0"
        class="genesys-call-log__field genesys-call-log__field--full"
      >
        <label class="horizon-form-input__label">
          {{
            "call_log.call_log_report_view.general.linked_account" | translate
          }}
        </label>
        <ul class="genesys-call-log__linked-accounts">
          <ng-container *ngFor="let linkedAccount of linkedAccounts; index as i">
            <li
              class="linked-account"
              [attr.data-qa]="'genesys-call-log_report_linked-account_' + i"
            >
              <horizon-checkbox-input
                [disabled]="!isEditMode"
                [checked]="linkedAccount.Selected"
                (valueClicked)="selectLinkedAccount(linkedAccount)"
              ></horizon-checkbox-input>
              <span class="linked-account__text">
                {{
                  (linkedAccount.accountRef ?? "") !== ""
                    ? linkedAccount.accountRef
                    : linkedAccount.AccountRef
                }}
              </span>
            </li>
          </ng-container>
        </ul>
      </div>
    </form>
    <!-- #endregion -->

    <!-- #region 3RD PARTY PANEL ACCORDION -->
    <accordion-section
      *ngIf="isThirdPartyPanel"
      data-qa="genesys-call-log_report_accordion_third-party"
      [isOpen]="true"
    >
      <!-- #region 3RD PARTY CALL LOG ACCORDION TITLE -->
      <ng-container accordion-title>
        <span>{{
          "call_log.call_log_report_view.3rd_party_panel.label" | translate
        }}</span>
      </ng-container>
      <!-- #endregion -->

      <!-- #region 3RD PARTY CALL LOG ACCORDION CONTENT -->
      <form
        accordion-content
        class="genesys-call-log__form-group"
        data-qa="genesys-call-log_report_form_third-party"
        [formGroup]="thirdPartyPanelForm"
      >
        <ng-container
          *ngFor="let thirdPartyPanelField of thirdPartyPanelFormGroupFields"
        >
          <div
            class="genesys-call-log__field"
            [attr.data-qa]="
              'genesys-call-log_report_third-party_field_' +
              thirdPartyPanelField.textId.value
            "
            *ngIf="(thirdPartyPanelField.answer?.value ?? '') !== ''"
          >
            <verification-label
              [label]="thirdPartyPanelField[currentLanguage].value"
              [isRequired]="false"
              [isDisabled]="!isEditMode || customerRefusesToVerify"
              [isChecked]="false"
              [valueSelected]="thirdPartyPanelField.result?.value"
              [labelFor]="thirdPartyPanelField.textId.value"
              (switchChanged)="switchChanged($event, 'ThirdParty')"
            ></verification-label>
            <horizon-text-input
              *ngIf="callDirection.includes('Outbound')"
              [disabled]="true"
              [name]="thirdPartyPanelField.textId.value"
              [control]="
                getControl(
                  thirdPartyPanelForm,
                  thirdPartyPanelField.textId.value
                )
              "
            ></horizon-text-input>
            <ng-container *ngIf="callDirection.includes('Inbound')">
              <horizon-otp-input
                *ngIf="isEditMode"
                [otpLength]="2"
                [otpValue]="thirdPartyPanelField.answer?.value"
              ></horizon-otp-input>
              <input
                *ngIf="!isEditMode"
                [value]="'************'"
                type="text"
                [disabled]="true"
              />
            </ng-container>
          </div>
        </ng-container>
      </form>
      <!-- #endregion -->
    </accordion-section>
    <!-- #endregion -->

    <!-- #region Id CALL LOG ACCORDION-->
    <accordion-section
      *ngIf="!isUnauthorised && !isTransferred && !isThirdPartyPanel"
      data-qa="genesys-call-log_report_accordion_id"
      [isOpen]="true"
    >
      <!-- #region Id CALL LOG ACCORDION TITLE -->
      <ng-container accordion-title>
        <span>{{ "call_log.call_log_report_view.id.label" | translate }}</span>
        <horizon-notification-msg
          [type]="'info'"
          [text]="'call_log.call_log_report_view.id.prompt'"
        ></horizon-notification-msg>
      </ng-container>
      <!-- #endregion -->

      <!-- #region Id CALL LOG ACCORDION CONTENT -->
      <form
        accordion-content
        class="genesys-call-log__form-group"
        data-qa="genesys-call-log_report_form_id"
        [formGroup]="identificationForm"
      >
        <ng-container
          *ngFor="let identificationField of identificationFormGroupFields"
        >
          <div
            class="genesys-call-log__field"
            [attr.data-qa]="
              'genesys-call-log_report_id_field_' +
              identificationField.textId.value
            "
            *ngIf="(identificationField.answer?.value ?? '') !== ''"
          >
            <verification-label
              [label]="identificationField[currentLanguage].value"
              [isRequired]="false"
              [isDisabled]="!isEditMode || customerRefusesToVerify"
              [isChecked]="false"
              [valueSelected]="identificationField.result?.value"
              [labelFor]="identificationField.textId.value"
              (switchChanged)="switchChanged($event, 'Id')"
            ></verification-label>

            <ng-container [ngSwitch]="identificationField.fieldType.value">
              <horizon-text-input
                *ngSwitchCase="'String'"
                [disabled]="true"
                [name]="identificationField.textId.value"
                [control]="
                  getControl(
                    identificationForm,
                    identificationField.textId.value
                  )
                "
              ></horizon-text-input>

              <horizon-datepicker
                *ngSwitchCase="'Date' || 'DateTime'"
                [format]="'dd/MM/yyyy'"
                [enabled]="false"
                [name]="identificationField.textId.value"
                [control]="
                  getControl(
                    identificationForm,
                    identificationField.textId.value
                  )
                "
              ></horizon-datepicker>

              <horizon-number-input
                *ngSwitchCase="'Int'"
                [showSpinButton]="false"
                [enabled]="true"
                [name]="identificationField.textId.value"
                [control]="
                  getControl(
                    identificationForm,
                    identificationField.textId.value
                  )
                "
              ></horizon-number-input>
            </ng-container>
          </div>
        </ng-container>
      </form>
      <!-- #endregion -->
    </accordion-section>
    <!-- #endregion -->

    <!-- #region VERIFICATION CALL LOG ACCORDION -->
    <accordion-section
      *ngIf="!isUnauthorised && !isTransferred && !isThirdPartyPanel"
      data-qa="genesys-call-log_report_accordion_verification"
      [isOpen]="true"
    >
      <!-- #region VERIFICATION CALL LOG ACCORDION TITLE -->
      <ng-container accordion-title>
        <span>{{
          "call_log.call_log_report_view.verification.label" | translate
        }}</span>
        <horizon-notification-msg
          [type]="'info'"
          [text]="'call_log.call_log_report_view.verification.prompt'"
        ></horizon-notification-msg>
      </ng-container>
      <!-- #endregion -->
      <!-- #region VERIFICATION CALL LOG ACCORDION CONTENT -->
      <form
        accordion-content
        class="genesys-call-log__form-group"
        data-qa="genesys-call-log_report_form_verification"
        [formGroup]="verificationForm"
      >
        <div
          class="genesys-call-log__field"
          *ngFor="let verificationField of verificationFormGroupFields"
          [attr.data-qa]="
            'genesys-call-log_report_verification_field_' +
            verificationField.textId.value
          "
        >
          <verification-label
            [isChecked]="false"
            [isDisabled]="!isEditMode || customerRefusesToVerify"
            [isRequired]="false"
            [label]="verificationField[currentLanguage].value"
            [valueSelected]="verificationField.result?.value"
            [labelFor]="verificationField.textId.value"
            (switchChanged)="switchChanged($event, 'Verification')"
          ></verification-label>

          <ng-container [ngSwitch]="verificationField.fieldType.value">
            <horizon-text-input
              *ngSwitchCase="'String'"
              [disabled]="true"
              [name]="verificationField.textId.value"
              [control]="
                getControl(verificationForm, verificationField.textId.value)
              "
            ></horizon-text-input>

            <horizon-datepicker
              *ngSwitchCase="'Date' || 'DateTime'"
              [enabled]="false"
              [format]="'dd/MM/yyyy'"
              [name]="verificationField.textId.value"
              [control]="
                getControl(verificationForm, verificationField.textId.value)
              "
            ></horizon-datepicker>

            <horizon-number-input
              *ngSwitchCase="'Int'"
              class="inputs__item"
              [enabled]="false"
              [name]="verificationField.textId.value"
              [showSpinButton]="false"
              [control]="
                getControl(verificationForm, verificationField.textId.value)
              "
            ></horizon-number-input>

            <ng-container *ngSwitchCase="'Password'">
              <horizon-otp-input
                *ngIf="isEditMode"
                [otpLength]="2"
                [otpValue]="verificationField.answer?.value"
              ></horizon-otp-input>
              <input
                *ngIf="!isEditMode"
                [value]="'************'"
                type="text"
                [disabled]="true"
              />
            </ng-container>
          </ng-container>
        </div>
      </form>
      <!-- #endregion -->
    </accordion-section>
    <!-- #endregion -->

    <!-- #region LEFT PANEL CALL LOG BUTTONS-->
    <div class="genesys-call-log__buttons">
      <div class="payment-button">
        <ng-container *ngIf="isEditMode">
          <horizon-notification-list
            [title]="'call_log.call_log_report_view.notifications.list.title'"
            [notifications]="paymentRequirementNotifications"
          ></horizon-notification-list>
          <!-- <horizon-notification-msg
            *ngFor="
              let paymentRequirementNotification of paymentRequirementNotifications
            "
            [type]="'warning'"
            [text]="paymentRequirementNotification"
            class="notification-messages"
          ></horizon-notification-msg> -->
        </ng-container>
        <div class="payment-button__bottom">
          <horizon-button
            *ngIf="isEditMode"
            #paymentButton
            [isDisabled]="
              isSuccessfulContact
                | disableReportPaymentButton
                  : isIDVStatusValid
                  : paymentRequirementNotifications
                  : isThirdPartyPanel
            "
            class="payment-button"
            [text]="'call_log.call_log_report_view.buttons.make_payment'"
            type="info"
            [buttonColor]="globalSettings.colors.mainColor"
            (click)="openPCIPalAction()"
          ></horizon-button>
          <horizon-notification-msg
            *ngIf="paymentNotification"
            data-qa="genesys-call-log_report_notification_payment"
            [type]="paymentNotification.status"
            [text]="paymentNotification.message"
            class="notification-messages"
          ></horizon-notification-msg>
        </div>
      </div>
      <div class="modal-buttons">
        <horizon-confirmation-buttons-set
          #buttonsSet
          [cancelObj]="buttonCancelProps"
          [confirmObj]="buttonConfirmProps"
          [isConfirmDisabled]="
            isEditMode
              | disableReportSaveButton
                : isCallSummaryPopulated
                : canUserEditCallSummary
                : isCallSummaryEdited
          "
          (cancelEvent)="close($event)"
          (confirmEvent)="saveData()"
        ></horizon-confirmation-buttons-set>
      </div>
    </div>
    <!-- #endregion -->
  </div>
  <!-- #endregion -->

  <!-- #region RIGHT PANEL CALL LOG-->
  <div class="genesys-call-log__right">
    <accordion-section
      data-qa="genesys-call-log_report_accordion_notes"
      [isOpen]="true"
    >
      <ng-container accordion-title>
        <span>{{
          "call_log.call_log_report_view.telephone_note_call_summary_panel.label"
            | translate
        }}</span>
      </ng-container>

      <ng-container accordion-content>
        <div class="genesys-call-log__content">
          <horizon-textarea
            data-qa="genesys-call-log_report_notes_textarea_telephone-note"
            [label]="'call_log.call_log_report_view.general.telephone_note'"
            [isAutoSize]="false"
            [isCustomSize]="true"
            [size]="'300px'"
            [isDisabled]="!isEditMode"
            [value]="telephoneNote"
            (valueChange)="textAreaChange('TelephoneNote', $event)"
          ></horizon-textarea>
        </div>
        <div class="genesys-call-log__content">
          <horizon-textarea
            data-qa="genesys-call-log_report_notes_textarea_call-summary"
            [label]="'call_log.call_log_report_view.general.call_summary'"
            [isAutoSize]="false"
            [isCustomSize]="true"
            [size]="'300px'"
            [isDisabled]="!isEditMode && !canUserEditCallSummary"
            [value]="callSummary"
            (valueChange)="textAreaChange('CallSummaryEdited', $event)"
          ></horizon-textarea>
        </div>
      </ng-container>
    </accordion-section>

    <div class="genesys-call-log__content">
      <div
        class="genesys-call-log__prompts"
        *ngFor="let prompt of prompts; index as i"
        [attr.data-qa]="'genesys-call-log_report_notification_prompt_' + i"
      >
        <horizon-notification-msg
          [type]="'info'"
          [text]="prompt[currentLanguage].value"
          class="notification-messages"
        ></horizon-notification-msg>
      </div>
    </div>
    <div class="genesys-call-log__content">
      <horizon-dropdown
        data-qa="genesys-call-log_report_general_dropdown_call-closure"
        class="inputs__item"
        [label]="'call_log.call_log_report_view.general.call_closure'"
        [dropdownValues]="callClosureOptions"
        [fields]="callClosureOptionsValues"
        [enabled]="isEditMode"
        [control]="generalForm?.controls['callClosure']"
        (valueSelected)="callClosureChanged($event)"
      ></horizon-dropdown>
      <!-- <horizon-button
        #CallClosureCodeButton
        [text]="'call_log.call_log_report_view.buttons.confirm_call_closure'"
        [type]="'info'"
        [isDisabled]="
          !isEditMode || !callClosureCodeSelected || !categorySelected
        "
        [buttonColor]="globalSettings.colors.mainColor"
        (clickEvent)="populateCallSummary()"
      ></horizon-button> -->
    </div>
    <accordion-section
      data-qa="genesys-call-log_report_accordion_reminders"
      [isOpen]="true"
    >
      <ng-container accordion-title>
        <span>{{
          "call_log.call_log_report_view.reminders_to_close.label" | translate
        }}</span>
      </ng-container>
      <div accordion-content class="genesys-call-log__content">
        <horizon-reminders-to-close
          *ngIf="isEditMode"
          class="genesys-call-log__reminders"
          [reminders]="reminders$ | async"
          [girdCellContentColor]="girdCellContentColor"
          (selectionChanged)="onReminderSelected($event)"
        ></horizon-reminders-to-close>
      </div>
    </accordion-section>
  </div>
  <!-- #endregion -->
</div>
